export default {
  get DATETIME () {
    return 'datetime'
  },
  get DATE () {
    return 'date'
  },
  get TIME () {
    return 'time'
  },
  get WEEK () {
    return 'week'
  },
  get MONTH () {
    return 'month'
  },
  get QUARTER () {
    return 'quarter'
  },
  get YEAR () {
    return 'year'
  }
}
